import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Dialog from '@react/react-spectrum/Dialog';
import Loader from '../Common/Loader';

export class CustomAgreementApproveDialog extends Component {
    constructor(props) {
        super(props);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDismiss = this.handleDismiss.bind(this);
    }

    handleConfirm = () => {
        
        if (this.props.confirm) {
            this.props.confirm();
        }
    };

    handleCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    };

    handleDismiss = (reason) => {
        
        // Prevent dismissal during loading
        if (this.props.isLoading) {
            return; // Don't close
        }
        
        // For backdrop, escape, or other dismiss reasons, allow closing
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    };

    // Helper function to get localized text
    getSalesText = (path, fallback = '') => {
        if (this.props.getSalesText) {
            return this.props.getSalesText(path, fallback);
        }
        
        // Fallback to using t prop if getSalesText not available
        const { t } = this.props;
        if (t) {
            try {
                const result = t(path, { defaultValue: null });
                if (result && result !== path) {
                    return result;
                }
            } catch (error) {
                console.warn('Error getting translation for path:', path, error);
            }
        }
        
        return fallback;
    };

    render() {
        const { isLoading, error } = this.props;

        
        return (
            <div data-am-id="agreementApproveModal">
                <Dialog
                    modalContent
                    role="dialog"
                    {...this.props}
                    title={this.getSalesText('NEW_ORDER.labels.details.acceptAgreement', 'Accept Agreement')}
                    confirmLabel={isLoading ? 
                        this.getSalesText('NEW_ORDER.labels.details.processing', 'Processing...') : 
                        this.getSalesText('NEW_ORDER.labels.details.confirmBtn', 'Confirm')
                    }
                    cancelLabel={this.getSalesText('NEW_ORDER.labels.details.cancelBtn', 'Cancel')}
                    onConfirm={this.handleConfirm}
                    onCancel={this.handleCancel}
                    onDismiss={this.handleDismiss}
                    confirmDisabled={isLoading}
                    backdropClickable={false}
                >
                    <div style={{ padding: '16px 0' }}>
                        {error && (
                            <div style={{ 
                                marginBottom: '16px', 
                                padding: '12px', 
                                backgroundColor: '#fee', 
                                border: '1px solid #fcc', 
                                borderRadius: '4px',
                                color: '#c33'
                            }}>
                                <strong>{this.getSalesText('NEW_ORDER.labels.details.error', 'Error')}: </strong>
                                {error}
                            </div>
                        )}
                        
                        {isLoading && (
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                marginBottom: '16px',
                                padding: '12px',
                                backgroundColor: '#f9f9f9',
                                borderRadius: '4px'
                            }}>
                                <div style={{ marginRight: '12px' }}>
                                    <Loader loaderSize="S" />
                                </div>
                                <span>{this.getSalesText('NEW_ORDER.labels.details.processingApproval', 'Processing approval request...')}</span>
                            </div>
                        )}
                        
                        <p style={{ marginBottom: '16px', fontSize: '14px', lineHeight: '1.5' }}>
                            {this.getSalesText('NEW_ORDER.labels.details.areYouSureApprove', 'Are you sure you want to approve this agreement?')}
                        </p>
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default withTranslation()(CustomAgreementApproveDialog);
